import type { SVGProps } from 'react';
const SvgRamenDining = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#ramen_dining_svg__a)">
      <path
        fill="currentColor"
        d="M9 6H8V4.65l1-.12V6Zm0 6H8V7h1v5ZM6 7h1v5H6V7Zm0-2.12 1-.12V6H6V4.88ZM22 3V2L5 4v8H2c0 3.69 2.47 6.86 6 8.25V22h8v-1.75c3.53-1.39 6-4.56 6-8.25H10V7h12V6H10V4.41L22 3Z"
      />
    </g>
    <defs>
      <clipPath id="ramen_dining_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRamenDining;
